const alerter = (string) => {
    alert(string);
}

export default alerter;